// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"data-display"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 5H4.5C5.05228 5 5.5 5.44772 5.5 6L5.5 15M5.5 15H4M5.5 15H7M10 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H11C10.4477 10 10 10.4477 10 11V15H14M17 15H20C20.5523 15 21 14.5523 21 14V10M17 5H20C20.5523 5 21 5.44772 21 6V10M21 10H17.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21 19H4","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-data-display')
export default class DataDisplayIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'data-display',
    }
  }
}
